import { createStore } from 'vuex'
import auth from './auth'
import reference from './reference'

export default createStore({
  strict: true,
  modules: { auth, reference },
})
